import React, { Component } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Modules() {
  const modules = [{
    icon: '📘',
    title: 'Módulo 1 — Anatomía de la Mampara',
    desc: 'Componentes, perfiles, herrajes y cristales con lenguaje de taller.'
  }, {
    icon: '📗',
    title: 'Módulo 2 — Relevamiento y Medición',
    desc: 'Protocolo de 3 puntos: plomo, escuadra y vanos críticos.'
  }, {
    icon: '📙',
    title: 'Módulo 3 — Sistemas Corredizos',
    desc: 'Kits, fórmulas de corte, armado y ajuste de punta a punta.'
  }, {
    icon: '📕',
    title: 'Módulo 4 — Cristales y Descuentos',
    desc: 'Fórmulas exactas para cada sistema. Sin calcular de cabeza.'
  }, {
    icon: '📓',
    title: 'Módulo 5 — Herrajes de Alta Gama',
    desc: 'Selección, posicionamiento y ajuste de herrajes premium.'
  }, {
    icon: '📔',
    title: 'Módulo 6 — Instalación y Sellado',
    desc: 'Nivelación, fijación, sellado en capas y checklist de obra.'
  }, {
    icon: '📒',
    title: 'Módulo 7 — Galería de Errores',
    desc: 'Los errores más comunes con foto, causa y solución.'
  }, {
    icon: '📃',
    title: 'Módulo 8 — Presupuestos y Negocio',
    desc: 'Costos reales, margen garantizado y cómo cobrar lo que vale.'
  }];
  const includes = ['Fórmulas listas para imprimir', 'Protocolos paso a paso', 'Checklists de verificación', 'Planillas A4 para el taller'];
  return <section className="py-12 bg-surface border-y border-white/5" data-id="element-227">
      <div className="container mx-auto px-4" data-id="element-228">
        <FadeIn data-id="element-229">
          <div className="text-center mb-10" data-id="element-230">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white" data-id="element-231">
              🏆 EL MAESTRO DE LAS MAMPARAS
            </h2>
            <p className="text-xl text-gold font-medium mb-2" data-id="element-232">
              8 Módulos + 3 Bonos — Corredizo → Batiente → Paño Fijo
            </p>
            <p className="text-gray-400" data-id="element-233">
              220+ páginas de fórmulas, checklists y protocolos. Todo resuelto.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10" data-id="element-234">
          {modules.map((mod, i) => <FadeIn key={i} delay={i * 0.05} data-id="element-235">
              <div className="bg-background p-6 rounded-2xl border border-white/10 hover:border-gold/50 transition-colors group h-full" data-id="element-236">
                <div className="text-4xl mb-4 group-hover:scale-110 transition-transform origin-left" data-id="element-237">
                  {mod.icon}
                </div>
                <h3 className="text-base font-bold mb-2 text-white leading-tight" data-id="element-238">
                  {mod.title}
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-239">{mod.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-240">
          
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-241">
          <div className="bg-background/50 p-8 rounded-2xl border border-white/5 max-w-4xl mx-auto" data-id="element-242">
            <h4 className="text-center text-lg text-gray-300 mb-6 font-medium" data-id="element-243">
              Cada módulo incluye:
            </h4>
            <div className="grid sm:grid-cols-2 gap-4" data-id="element-244">
              {includes.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-245">
                  <CheckCircle2 className="w-5 h-5 text-gold shrink-0" data-id="element-246" />
                  <span className="text-gray-200" data-id="element-247">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}